import { CheckItemRecord } from "./CheckItemRecord";
import { MenuItemPriceList } from "./MenuItemPriceList";
import { MenuItemTax } from "./MenuItemTax";
import { ModifierCanvas } from "./ModifierCanvas";
import { ReportGroup } from "./ReportGroup";
import { Store } from "./Store";
import { StoreCheckItemRecord } from "./StoreCheckItemRecord";

export class MenuItemRecord {
	venueKey: number;
	RecordNumber: number;
	ID: string = undefined;
	INVENTORYID: string = undefined;
	GuestCheckName: string = undefined;
	SortKey: string = undefined;
	MenuName: string = undefined;
	RemoteName: string = undefined;
	AudioFile: string = undefined;
	SuggestionText: string = undefined;

	ReportGroup: number;
	Type: number;
	PrinterGroupID: number;
	CourseID: number;
	BeverageSatisfiesCount: number;
	Concept: number;
	MealStageID: number;
	DblPercent: number;
	PriceLevelID: number;
	Priority: number;
	Count: number;
	Cost: number;

	ConversationalMods: boolean;
	IncludeInItemPrice: boolean;
	Deleted: boolean;
	SatisfiesBeverage: boolean;
	RequiresBeverage: boolean;
	GuestCheck: boolean;
	VariablePrice: boolean;
	KitchenComment: boolean;
	FollowItem: boolean;
	Countdown: boolean;
	OutOfStock: boolean;
	RepeatRound: boolean;
	KitchenPrice: boolean;
	Scale: boolean;
	RequestTareWeight: boolean;
	IncrementGuests: boolean;
	FractionQuantity: boolean;
	Inventoried: boolean;
	FoodStampEligible: boolean;
	TimedRate: boolean;
	SteeringModifier: boolean;
	ReclassifyTax: boolean;
	QuantityPrompt: boolean;
	PositionPrompt: boolean;
	RequireApproval: boolean;

	ImageName: string = undefined;

	MenuItemPriceList: MenuItemPriceList;

	CheckItem: CheckItemRecord[];

	ModifierCanvas: ModifierCanvas[];

	MenuItemTaxes: MenuItemTax[];

	StoreCheckItemRecord: StoreCheckItemRecord[];

	ReportGroupRecord: ReportGroup;

	stores: Store;

	public constructor(init?: Partial<MenuItemRecord>) {
		Object.assign(this, init);
	}
}
